<br><br><br><br><br><br>
<div class="form-gap"></div>
    <div class="d-flex justify-content-center">
		<div class="col-md-4 col-md-offset-4">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="text-center">
                  <h3><i class="fa fa-lock fa-4x"></i></h3>
                  <h2 class="text-center">Mot de passe oublié ?                  </h2>
                  <p>Vous pouvez réinitialiser votre mot de passe ici.</p>
                  <div class="panel-body">
    
                    <form id="register-form" role="form" autocomplete="off" class="form" method="post">
    
                      <div class="form-group">
                        <div class="input-group">
                          <span class="input-group-addon"><i class="glyphicon glyphicon-envelope color-blue"></i></span>
                          <input  [(ngModel)]="email" id="email" name="email" placeholder="Email" class="form-control"  type="email">
                        </div>
                      </div>
                      <div class="form-group">
                        <input *ngIf="!showSpinner" (click)="reset()" name="recover-submit" class="btn btn-lg btn-primary btn-block" value="Réinitialiser mot de passe" type="submit">
                        <button *ngIf="showSpinner" (click)="reset()" name="recover-submit" class="btn btn-lg btn-primary btn-block" value="Réinitialiser mot de passe" type="submit">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Chargement en cours...
                        </button>
                      </div>
                      
                    </form>
                    <mat-error  *ngIf="emailnonvalide"> Verifier le email</mat-error>
                    <mat-error  *ngIf="emailnexistepas"> Email n'exsite pas, veillez s'inscrit <a routerLink="/signup"> ici </a></mat-error>

                  </div>
                </div>
              </div>
            </div>
        </div>
</div>
<br><br><br><br><br><br><br><br>